function initFormTab() {
    const form = $('form.journal_entry')
    form.on('keydown', function (e) {
        if (e.key === 'Tab') {
            e.preventDefault(); // stop browser’s default tab navigation
        }
    });
    const $inputs = form.find('input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), .select2.select2-container.select2-container--classic')
        .filter(':visible')
        .filter((i, x) => !$(x).hasClass('pointer-events-none'))
        .filter((i, x) => !$(x).hasClass('select2-hidden-accessible'))
        .filter((i, x) => {
            return (!$(x).is('[readonly]')) || ($(x).is('[readonly]') && $(x).hasClass('flatpickr'))
        })
        .sort(function (a, b) {
            return $(a).offset().top - $(b).offset().top || $(a).offset().left - $(b).offset().left;
        });

    $.each($inputs, function (i, input) {
        const $input = $(input)
        $input.off('keydown.tab-press')
        $input.on('keydown.tab-press', function (e) {
            if (e.key === 'Tab') {
                e.preventDefault();
                if (e.shiftKey) {
                    // Shift + Tab → go backwards
                    focusNextInput($inputs, this, -1);
                } else {
                    // Normal Tab → go forward
                    focusNextInput($inputs, this, +1);
                }
            }
        });
    })
}

function focusNextInput($inputs, currentElement, step) {

    const index = $inputs.index(currentElement);
    if (index !== -1 && index + step < $inputs.length) {
        const $next = $($inputs[index + step]);
        // Se è select2
        if ($next.hasClass('select2-container')) {
            // Find the underlying select
            let $select = $next.prev('select.select2-hidden-accessible');
            if ($select.length) {
                $select.select2('open');
            }
        }
        // Se è flatpickr
        else if ($next.hasClass('flatpickr-input')) {
            $next.focus();
            $next.flatpickr().open(); // apri il calendario
        }
        // Se è AutoNumeric
        else if ($next.data('autoNumeric')) {
            $next.focus(); // AutoNumeric gestisce già il focus bene
        }
        // Altro input normale
        else {
            $next.focus();
        }
    }
}

export {initFormTab}